import { SpecialOffersUI } from "./SpecialOffersUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { hasSizes } from "../../utils/product/hasSizes";
import { useRouter } from "next/router";
import { getSizeQuery } from "../../utils/routing/getSizeQuery";
import { removeIFCMessages } from "../../utils/product/interestFreeCredit/removeIFCMessages";
import { postMonetateImpression } from "../../utils/monetate/postMonetateImpression";
import { Experience } from "../../types/types";
import { logger } from "@/utils/logger";

export function SpecialOffers({
  product,
  experiences,
  experiencesRawString,
  runtimeConfig,
  configProps,
}: Pick<
  StandardProps,
  | "product"
  | "experiences"
  | "experiencesRawString"
  | "runtimeConfig"
  | "configProps"
>) {
  const router = useRouter();
  const sizeParam = getSizeQuery(router.query);
  const { variant } = useVariant(product);
  const productHasSizes = hasSizes(product);
  const isVariantExplicitlySelected = productHasSizes && sizeParam;

  const messages =
    (isVariantExplicitlySelected ? variant.messaging : product.messaging) || [];

  const cleanedMessages = removeIFCMessages(messages);

  const { newPromoDrawer, newPromoListItem, oldPromoAccordion } = experiences;

  const hidePromoDrawer =
    typeof configProps?.hidePromoDrawer == "boolean"
      ? configProps.hidePromoDrawer
      : false;

  const drawerOpenPostImpression = () => {
    let customerTagsDrawerExperience;

    try {
      if (experiencesRawString) {
        const decodedExperiences = Buffer.from(
          experiencesRawString,
          "base64",
        ).toString("utf8");
        const detailedExperiences = JSON.parse(decodedExperiences);
        customerTagsDrawerExperience = detailedExperiences.find(
          (experience: Experience) => {
            if (experience.parameters) {
              return Object.prototype.hasOwnProperty.call(
                experience.parameters,
                "pdp-scaffold-newPromoDrawer",
              );
            } else {
              return false;
            }
          },
        );
      }
    } catch (error) {
      logger(
        "error",
        "Error in SpecialOffers component when parsing experiencesRawString",
        undefined,
        {
          experiencesRawString: experiencesRawString,
        },
      );
    }

    const monetateEnvironment = runtimeConfig.monetateEnvironment;

    if (
      monetateEnvironment &&
      customerTagsDrawerExperience &&
      customerTagsDrawerExperience.impressionId
    ) {
      postMonetateImpression(
        customerTagsDrawerExperience.impressionId,
        monetateEnvironment,
      );
    }
  };

  const isNewPromoDrawer = newPromoDrawer === "on";
  if (!isNewPromoDrawer && (hidePromoDrawer || oldPromoAccordion === "on"))
    return null;

  return (
    <SpecialOffersUI
      messages={cleanedMessages}
      isNewPromoListItem={newPromoListItem === "on"}
      isNewPromoDrawer={isNewPromoDrawer}
      drawerOpenPostImpression={drawerOpenPostImpression}
    />
  );
}
